import React, { Component } from "react";
import { Auth } from "aws-amplify";
import {states} from './loginConstants';

import { withStyles,
    Card, CardActions, CardContent,
    Button, Typography, TextField, Link, Grid, CircularProgress } from '@material-ui/core';
import { ArrowBack } from '@material-ui/icons';

const styles = theme => ({
    card: {
        width: 400,
        padding: 30
    },
    cardActions: {
        padding: 16
    },
    title: {
        padding: 15,
        paddingLeft: 0
    },
    back: {
        fontSize: 12
    },
    input: {
        fontSize: 14
    },
    arrow: {
        fontSize: 10
    }
})

export default withStyles(styles)(class ChangePassword extends Component {
    state = {
        handling: false
    }

    handleChangePassword = event => {
        this.setState({handling: true});
        event.preventDefault();
        const { newPassword, username, password } = this.props.inputs;

        Auth.signIn({username, password})
            .then(user => {
                Auth.completeNewPassword(user, newPassword)
                    .then(user => {
                        this.setState({handling: false});
                        this.props.setNewPassword();
                        this.props.switchComponent(states.VERIFY);
                    })
                    .catch(err => {
                        if (err.code) {
                             this.props.openSnackbar(true, "error", err.message);
                        }
                        else this.props.openSnackbar(true, "error", "Password cannot be empty.");
                        this.setState({handling: false});
                    });
            })
            .catch(err => {
                console.log(err);
                this.setState({handling: false});
            });
    }

    render() {
        const {classes} = this.props;
        const {handling} = this.state;
        return (<Card className={classes.card}>
            <CardContent>
            <Typography variant="h6" className={classes.title}>
                <b>Change Password</b>
            </Typography>
            <TextField fullWidth
                type="password"
                name="newPassword"
                value={this.props.inputs.newPassword}
                label={`New Password`}
                placeholder={`Enter your new password`}
                onChange={this.props.handleFormInput}
                margin="normal"
                InputProps={{ className: classes.input}}
                InputLabelProps={{ shrink: true }}
                variant="outlined"
            />
            </CardContent>

            <CardActions className={classes.cardActions}>
                <Grid container justifyContent="space-between" alignItems="center">
                    <Grid item>
                        <Typography variant="body2">
                            <Link href="#" onClick={() => this.props.switchComponent(states.SIGN_IN)}>
                                <ArrowBack className={classes.arrow}/> <span className={classes.back}>Back to Sign In</span>
                            </Link>
                        </Typography>
                    </Grid>
                    <Grid item>
                        <Button
                            variant="contained"
                            color="primary"
                            size="large"
                            onClick={this.handleChangePassword}
                            disabled={handling}
                            endIcon={handling ? <CircularProgress size={20}/> : null}
                        >
                            <b>CHANGE</b>
                        </Button>
                    </Grid>
                </Grid>
            </CardActions>
        </Card>)
    }

})